import RestService from '../services/rest';


async function getAllAverageCosts(tableParams) {
  return RestService.postAuthenticated('averageCost/list/all', tableParams);
};

export default {
  getAllAverageCosts,
};